import { Heading, HeadingLevel } from "@ariakit/react";
import Link from "next/link";
import Image from "next/image";

import type { Topic } from "../../types/content";

import styles from "./TopicTeaser.module.scss";
import teaserStyles from "./Teaser.module.scss";
import { Illustration } from "../Illustration/Illustration";
import { imageSrc, sizeNameToSizeValues } from "../../utils/image";

function TopicTeaserImage({ topic }: { topic: Topic }) {
  if (!topic.image) {
    return <Illustration variant="topic" size="small" upscale={true} />;
  }
  const imageUrl = imageSrc("small", true, topic.image);
  const imgProps = sizeNameToSizeValues["small"];
  return (
    <div className={styles.topicTeaserImage}>
      <Image
        src={imageUrl}
        width={imgProps.width}
        height={imgProps.height}
        alt={topic.title}
      />
    </div>
  );
}

export function TopicTeaser({ topic }: { topic: Topic }) {
  const topicPath = `/t/${topic.topic_id}`;

  return (
    <div className={teaserStyles.teaserContainer}>
      <HeadingLevel>
        <div className={styles.topicTeaser}>
          <Link
            href={topicPath}
            className={styles.topicTeaserContent}
            aria-label={topic.title}
          >
            <TopicTeaserImage topic={topic} />
            <div className={styles.topicTeaserContentWrapper}>
              <Heading className={styles.topicTeaserTitle}>
                {topic.title}
              </Heading>
            </div>
          </Link>
        </div>
      </HeadingLevel>
    </div>
  );
}
